import { useMediaQueries } from '@react-hook/media-query'
import { useMemo } from 'react'


type breakpoint_t = 'minW320' | 'maxW320' | 'minW480' | 'maxW480' | 'minW560' | 'max560' | 'minW600' | 'maxW600' | 'minW900' | 'maxW900' | 'minW1200' | 'maxW1200'
/** Keep the array consistent with `breakpoint_t` */
const BREAKPOINTS = [320, 480, 560, 600, 900, 1200]

export const useMediaQuery = () => {
    const breakpoints = useMemo(() => {
        const o = {} as rec_t<breakpoint_t, string>
        BREAKPOINTS.forEach(b => {
            const min = `minW${b}` as breakpoint_t
            const max = `maxW${b}` as breakpoint_t
            o[min] = `(min-width: ${b}px)`
            o[max] = `(max-width: ${b}px)`
        })
        return o
    }, [])

    return useMediaQueries(breakpoints)

}

export const setWindowTitle = (arg?: string) => {
    let env = window.location.host?.startsWith('localhost') ? 'local' : process.env.REACT_APP_ENVIRONMENT_PREFIX || ''
    env = env ? ` [${env}]` : ''
    document.title = `${arg || 'Syngenta'} | CPD HUB${env}`
}
